window.$ = window.jQuery = require('jquery');
$(function(){

    var gaClickTargets = $('.ga-click');

    var sendClickEvent = function(data){
        var category = data.category || 'Unspecified'; // 'Home Hero'
        var action = data.action || 'Click'; // 'Button Click'
        var value = data.value || 'false';
        var label = data.label || 'false';
        if (data.fields && data.fields.length >= 1) {
            ga('send', 'event', category, action, label, value, data.fields);
        } else {            
            ga('send', 'event', category, action, label, value);
        }
    };

    window.sendClickEvent = sendClickEvent;

    $(document).on('click touchstart', '.ga-click', function(evt){


        evt.preventDefault();

        var theCategory = $(this).attr('data-ga-category');
        var theAction = $(this).attr('data-ga-action');
        var theLabel = $(this).attr('data-ga-label');

        sendClickEvent({
            category: theCategory,
            action: theAction,
            value: theLabel
        });

        if(theLabel.indexOf('http') == 0 || theLabel.indexOf('localhost') != -1 || theLabel.indexOf('//') == 0){
            window.location = theLabel;
        } else if (this.hash && location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
            }
        } else {
            console.error('Error - No valid condition met in tracking script, label: ', theLabel);
        }


    });

}());